import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalCloseButton,
  Button,
  Text,
  VStack,
} from '@chakra-ui/react';

interface DropRockModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

/**
 * Drop Rock Modal Component
 * Confirmation modal for marking a rock as dropped
 * Migrated from Tailwind to Chakra UI
 */
export function DropRockModal({ isOpen, onClose, onConfirm }: DropRockModalProps) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="md">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Drop Rock</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <VStack spacing={4} align="stretch">
            <Text>Are you sure you want to drop this rock?</Text>
            <Text fontSize="sm" color="gray.600">
              This will mark the rock as dropped. This action can be undone later.
            </Text>
          </VStack>
        </ModalBody>
        <ModalFooter>
          <Button variant="ghost" mr={3} onClick={onClose}>
            Cancel
          </Button>
          <Button colorScheme="red" onClick={onConfirm}>
            Drop Rock
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}

